import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

export function useGameRouteId(stage) {
    const { gameId: routeGameId } = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    const stateGameId = location.state?.gameId
    const gameId = routeGameId || stateGameId

    useEffect(() => {
        // 兼容旧入口，并统一转换成包含比赛 ID 和流程阶段的正式 URL。
        if (!routeGameId && stateGameId) {
            navigate(`/games/${stateGameId}/${stage}`, {
                replace: true,
                state: location.state,
            })
            return
        }

        if (!gameId) {
            navigate('/home', { replace: true })
        }
    }, [gameId, location.state, navigate, routeGameId, stage, stateGameId])

    return gameId
}

